<template>
  <v-dialog
    v-bind="$attrs"
    v-on="$listeners"
    overlay-color="black"
    overlay-opacity="0.75"
    class="dialog-modal-clases"
    style="border: 2px solid white;"
    :width="tamañoModal"
  >
    <v-card class="dialog-modal-clases__card" width="100%">
      <v-col cols="12" class="d-flex flex-column pt-0">
        <v-row class="dialog-modal-clases__title-container py-10 px-10" justify="center">
          <div class="dialog-modal-clases__title-style-container d-flex justify-space-between">
            <p class="dialog-modal-clases__title-style mb-0">{{ message }}</p>
          </div>
        </v-row>
        <v-row class="py-10">
          <v-slide-group
            v-model="model"
            class="pa-4 mx-auto"
            center-active
            show-arrows
          >
            <v-slide-item
              v-for="publicidad in publicidadesClases" :key="publicidad.nombre"
              v-slot:default="{ toggle }"
              class="my-1"
              style="width: 170px;"
            >
              <v-card
                @click="toggle"
                height="209px"
                class="dialog-modal-clases__clase-card ma-2"
                elevation="3"
                :href="publicidad.url" target="_blank"
              >
                <v-row
                  class="d-flex flex-column fill-height mx-auto py-5 dialog-modal-clases__row"
                  align="center"
                  justify="center"
                >
                  <v-img :src="publicidad.imagen" min-width="60px" max-height="60px" contain/>
                  <div class="pt-2 mt-3 px-10 dialog-modal-clases__clase-card-text text-center">
                    {{ publicidad.nombre }}
                  </div>
                </v-row>
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-row>
      </v-col>
    </v-card>
  </v-dialog>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
  components: {},
  props: {},
  data () {
    return {
      message: 'En USAMEDIC puedes tomar diferentes cursos para complementar tu preparación',
      model: 0
    }
  },
  methods: {
    ...mapActions('banqueo', ['fetchPublicidadesClases'])
  },
  computed: {
    ...mapState('banqueo', ['publicidadesClases']),
    tamañoModal () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '90%'
        case 'sm':
          return '80%'
        case 'md':
          return '60%'
        case 'lg':
          return '50%'
        case 'xl':
          return '35%'
        default:
          return '50%'
      }
    }
  },
  mounted () {
    this.fetchPublicidadesClases()
  }
}
</script>

<style lang="scss" scoped>
.dialog-modal-clases {
  border-radius: 20px!important;

  &__card {
    border-radius: 20px !important;
  }
  &__row {
    border-radius: 20px;
  }

  &__benefits {
    width: 90%;
  }

  &__title-container {
    background: linear-gradient(90deg, rgba(31, 193, 208, 1), rgba(5, 131, 218, 1));
    border-radius: 20px;
    min-height: 152px;
    overflow: hidden;
  }

  &__title-style-container {
    width: 100%;
  }

  &__title-style {
    font-size: 20px;
    font-weight: 600;
    color: white;
    width: 100%;
  }

  &__message-style {
    font-size: 13px;
    font-weight: 400;
    width: 100%;
  }

  &__clase-card{
    border-radius:20px;
  }
  &__clase-card-text{
    font-size: 13px;
    font-weight: 400;
  }
}
</style>
